/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Aggregation is the grouping of project energy data.
 *
 */
export var Aggregation;
(function (Aggregation) {
    Aggregation["HOURLY"] = "hourly";
    Aggregation["DAILY"] = "daily";
    Aggregation["WEEKLY"] = "weekly";
    Aggregation["MONTHLY"] = "monthly";
    Aggregation["DAYWISE_MONTH"] = "daywiseMonth";
})(Aggregation || (Aggregation = {}));
